
<template>
    <div id="footer">
        <div class="brand">All content &copy; copyright {{ new Date().getFullYear() }} Lane Clark &amp; Peacock LLP. All rights reserved.</div>
    </div>
</template>

<script>
export default {
    name: 'selectFooter',
    data () {
        return {
        };
    },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/all.scss';
#footer{
    background-color: $darkBlue;
    bottom: 0;
    color: white;
    font-size: 10px;
    padding: 5px 20px;
    position: fixed;
    width: 100%;
}
</style>
